import React, { useState, useEffect, memo } from 'react';
import CommonIframe from '../components/common/Iframe';
import TranslateFile from '../Loc/TranslateFile';
import { useSelector } from 'react-redux';
import useKioskRestrictIntervalValidation from '../hooks/useKioskRestrictIntervalValidation';
import { getStoredValue } from "../../src/_helpers/storageHelper";

const LawLibrary = () => {

    const LoadInmateMainMenuDetails = getStoredValue("inmateMenuList");
    const [link, setLink] = useState(null);
    const currentLang = TranslateFile();
    const isPageReloading = useSelector((state) => state.auth?.isPageReload);
    const validateKioskRestrictInterval = useKioskRestrictIntervalValidation();
    const storedLoginDetails = getStoredValue("loginDetails");


    useEffect(() => {
        if (LoadInmateMainMenuDetails && LoadInmateMainMenuDetails.length > 0) {
            const menuLink = LoadInmateMainMenuDetails.find(m => m.MenuName === "Law Library");
            if (menuLink) {
                setLink(menuLink.MenuExternalLink); // Assuming MenuExternalLink contains the URL
            }
        }
    }, [LoadInmateMainMenuDetails, isPageReloading]);


    useEffect(() => {
        validateKioskRestrictInterval(storedLoginDetails)
    }, []);

    return (
        <div className="dashboard-container">
            <div className="dashboard-content">
                <div className="icon-container">
                    <h3 className="find-inmate-head">{currentLang?.Law_Library}</h3>
                </div>
                <div className="divider mb-3"></div>
                <div className='card-default'><CommonIframe url={link} /></div>

            </div>
        </div>
    );
};

export default memo(LawLibrary);
